import React, { Component } from 'react';
import { Card, CardHeader, CardContent, CardActions, Button, Typography } from '@mui/material';
import { connect } from 'react-redux'
import { sides } from './reducer'
import { withRouter } from '../../withRouter';
import styled from 'styled-components'


const Container = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
`

const StyledCard = styled(Card) `
    width: 500px;
`

class Login extends Component {

    onClickLogin = () => {

        this.props.authLogin()
    }

    render() {

        return (
            <Container>
                <StyledCard>
                    <CardHeader title="Goldie Bot" subheader="Administration page" />
                    <CardContent>
                        <Typography>You are not logged in, please click Login</Typography>
                    </CardContent>
                    <CardActions>
                        <Button onClick={this.onClickLogin} color="primary">Login</Button>
                    </CardActions>
                </StyledCard>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {

    return state.auth;
}

const mapDispatchToProps = (dispatch) => {

    return {
        authLogin() {
            dispatch(sides.login())
        }
    }
}

const LoginWithRouter = withRouter(Login)

export default connect(mapStateToProps, mapDispatchToProps)(LoginWithRouter)
